module.exports = __webpack_public_path__ + "img/user.ce7f1702.svg";